import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { GraphQLFetchPolicies } from 'shared/enums/GraphQLFetchPolicies';
import {
  ChannelStatusAction,
  EnumChannelStatusActionFilter,
  GetExistingChannelMembersQuery,
  GetExistingChannelMembersQueryVariables,
  GetExistingChannelMembersDocument,
} from 'shared/types/graphql';

interface IUseGetExistingChannels {
  clinicPetParentIds: string[];
  channelStatusAction?: EnumChannelStatusActionFilter;
}

const useGetExistingChannels = (): ((options: IUseGetExistingChannels) => Promise<string[]>) => {
  const apolloClient = useApolloClient();

  const getExistingChannels = useCallback(
    async ({
      clinicPetParentIds,
      channelStatusAction = { equals: ChannelStatusAction.Active },
    }: IUseGetExistingChannels) => {
      const result = await apolloClient.query<GetExistingChannelMembersQuery, GetExistingChannelMembersQueryVariables>({
        query: GetExistingChannelMembersDocument,
        variables: { clinicPetParentIds, channelStatusAction },
        fetchPolicy: GraphQLFetchPolicies.NetworkOnly,
      });
      return (result.data.findManyChannelMember || []).map(({ channel }) => channel?.id || '');
    },

    [apolloClient],
  );

  return getExistingChannels;
};

export default useGetExistingChannels;
